import {ConsoleDebug} from "../../../_utils/ConsoleDebug";

/**
 * Dialog component that can act as tooltip or modal dialog
 * Manually instantiates its markup and behaviors without extending a framework view
 */
export class Dialog {
  constructor({
                triggerEl,
                content,
                title,
                role,
                modal,
                extraClass,
                closeLabel,
                id,
                containerEl
              }) {
    // Assign configuration
    this.logInstance = new ConsoleDebug('debug-dialog', 'Dialog');

    this.logInstance.log(`Dialog constructor called for id=${id}`);
    this.triggerEl  = triggerEl;
    this.content    = content;
    this.title      = title;
    this.role       = role;
    this.modal      = modal;
    this.extraClass = extraClass;
    this.closeLabel = closeLabel;
    this.id         = id;
    this.container  = containerEl || triggerEl.parentNode;

    this.dialogEl = null;

    // Immediately build and bind the dialog
    this.createDialog();
    this.bindEvents();
  }

  /** Generate and attach the dialog element */
  createDialog() {
    this.logInstance.log(`createDialog called for id=${this.id}`);
    if (this.dialogEl) return;

    this.dialogEl = document.createElement('div');
    this.dialogEl.id = this.id;
    this.dialogEl.setAttribute('role', this.role);
    this.dialogEl.setAttribute('aria-labelledby', `${this.id}-title`);
    this.dialogEl.setAttribute('aria-describedby', `${this.id}-body`);
    if (this.modal) {
      this.dialogEl.setAttribute('aria-modal', 'true');
    }
    this.dialogEl.setAttribute('tabindex', '-1');
    this.dialogEl.className = `dialog ${this.extraClass}`.trim();
    this.dialogEl.hidden = true;

    // Title
    const titleEl = document.createElement('h2');
    titleEl.id = `${this.id}-title`;
    titleEl.className = 'dialog__headline';
    titleEl.textContent = this.title;
    this.dialogEl.appendChild(titleEl);

    // Content
    const contentEl = document.createElement('div');
    contentEl.id = `${this.id}-content`;
    contentEl.className = 'dialog__content';
    contentEl.innerHTML = this.content;
    this.dialogEl.appendChild(contentEl);

    // Close Button
    const closeBtn = document.createElement('button');
    closeBtn.className = 'dialog__close';
    closeBtn.setAttribute('aria-label', this.closeLabel);
    this.dialogEl.appendChild(closeBtn);

    this.container.appendChild(this.dialogEl);
    this.logInstance.log(`Dialog element appended with id = ${this.id}`);
  }

  bindEvents() {
    const closeBtn = this.dialogEl.querySelector('.dialog__close');
    closeBtn?.addEventListener('click', this.close);
  }

  /** Open the dialog */
  open() {
    if (!this.dialogEl) return;
    this.dialogEl.hidden = false;
    this.triggerEl?.setAttribute('aria-expanded', 'true');
    this.dialogEl.focus();
  }

  /** Close the dialog */
  close() {
    if (!this.dialogEl) return;
    this.dialogEl.hidden = true;
    this.triggerEl?.setAttribute('aria-expanded', 'false');
  }


  /** Toggle between open and close */
  hover() {
    if (!this.dialogEl) return;
    return this.dialogEl.hidden ? this.open() : this.close();
  }
}
